module.exports = __webpack_public_path__ + "img/copymob.16d3415b.svg";